handleRedirectFromDomain()

function handleRedirectFromDomain() {
  const domain = getRedirectFromDomain()
  if (domain) saveRedirectFromDomain(domain)
}

function getRedirectFromDomain(): string | undefined {
  const key = '__from'
  const url = new URL(window.location.href)
  const from = url.searchParams.get(key)
  if (from) {
    url.searchParams.delete(key)
    history.replaceState(null, '', url)
    return from
  }
}

function saveRedirectFromDomain(domain: string) {
  if (domain) {
    try {
      const stringified = JSON.stringify(domain)
      window.sessionStorage.setItem('tria__redirect-from-domain', stringified)
    } catch (ignore) {
      // ignore
    }
  }
}
